import { AccordionCivilStatus as CivilStatusVM } from 'shell/view-models/accordion-civil-status';
import { CivilStatus } from 'shell/models/person/civil-status';

export const transformCivilStatus = (
  values: CivilStatusVM | undefined
): CivilStatus | undefined => {
  const originReturnData: CivilStatus | undefined = values
    ? {
        statoCivile: values.status || undefined,
        statoCivileND: values.available ? 'S' : undefined,
        noteStatoCivile: values?.note || undefined,
      }
    : undefined;

  return originReturnData;
};
